import { render, staticRenderFns } from "./uOttawaVideosDescriptionFr.vue?vue&type=template&id=093aaa7d&scoped=true&"
import script from "./uOttawaVideosDescriptionFr.vue?vue&type=script&lang=ts&"
export * from "./uOttawaVideosDescriptionFr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093aaa7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
